import { phoneAuthAdminQueryKeys as e } from "./phoneAuthAdminQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { adminPhoneAuthApi as n } from "@maat/api-main";
//#region src/phoneAuth/admin/usePhoneAuthTransactionsQuery.ts
var r = (r = {}) => t({
	queryKey: e.transactions(r),
	fetchPage: (e) => n.listTransactions({
		...r,
		page: e
	}),
	key: "items"
});
//#endregion
export { r as usePhoneAuthTransactionsQuery };
